import { render, staticRenderFns } from "./inviteIntoCompany.vue?vue&type=template&id=28125436&"
import script from "./inviteIntoCompany.vue?vue&type=script&lang=js&"
export * from "./inviteIntoCompany.vue?vue&type=script&lang=js&"
import style0 from "./inviteIntoCompany.vue?vue&type=style&index=0&id=28125436&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports